import React, { PropsWithChildren } from 'react';

import { noticeError } from '../ui/newrelic/newrelic';

class ErrorLogger extends React.Component<PropsWithChildren> {
  componentDidCatch(error, errorInfo) {
    noticeError(error, { errorInfo });
  }

  render() {
    return this.props.children;
  }
}

export { ErrorLogger };
